import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "left_menu" }
const _hoisted_2 = { class: "left_gnb" }
const _hoisted_3 = { class: "depth_01" }
const _hoisted_4 = {
  key: 0,
  class: "depth_02"
}
const _hoisted_5 = {
  key: 0,
  class: "depth_02"
}
const _hoisted_6 = { class: "utility_wrap" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          ($setup.hasRole('action'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass({
                        active:
                            $setup.route.path === '/memberList' ||
                            $setup.route.path === '/adminList' ||
                            $setup.route.path === '/letterAgreeList' ||
                            $setup.route.path.startsWith('/action') ||
                            $setup.state.isShowSub1,
                    }),
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($setup.state.isShowSub1 = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($setup.state.isShowSub1 = false))
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                  _createElementVNode("span", { class: "menu_icon" }, [
                    _createElementVNode("img", {
                      src: "img/menu_user.png",
                      alt: ""
                    })
                  ]),
                  _createTextVNode(" 회원/관리자 관리 ")
                ], -1)),
                (
                            $setup.route.path === '/memberList' ||
                            $setup.route.path === '/adminList' ||
                            $setup.route.path === '/letterAgreeList' ||
                            $setup.route.path.startsWith('/action') ||
                            $setup.state.isShowSub1
                        )
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                      _createElementVNode("li", {
                        class: _normalizeClass({ active: $setup.route.path === '/memberList' })
                      }, [
                        ($setup.hasRole())
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/memberList"
                            }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode("회원관리", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("li", {
                        class: _normalizeClass({ active: $setup.route.path === '/adminList' })
                      }, [
                        ($setup.hasRole())
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/adminList"
                            }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("관리자관리", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("li", {
                        class: _normalizeClass({ active: $setup.route.path === '/letterAgreeList' })
                      }, [
                        ($setup.hasRole())
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/letterAgreeList"
                            }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode("뉴스레터 수신동의", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("li", {
                        class: _normalizeClass({ active: $setup.route.path.startsWith('/action') })
                      }, [
                        ($setup.hasRole('action'))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/action/group"
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("액션 시민 그룹", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true)
              ], 34))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            class: _normalizeClass({
                        active:
                            $setup.route.path === '/mainPage' ||
                            $setup.route.path === '/reportList' ||
                            $setup.route.path === '/activityList' ||
                            $setup.route.path === '/activityManageList' ||
                            $setup.route.path === '/activityStateList' ||
                            $setup.route.path === '/eventList' ||
                            $setup.route.path === '/newsList' ||
                            $setup.route.path === '/archiveList' ||
                            $setup.route.path === '/qnaList' ||
                            $setup.state.isShowSub2,
                    }),
            onMouseover: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isShowSub2 = true)),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => ($setup.state.isShowSub2 = false))
          }, [
            _cache[17] || (_cache[17] = _createElementVNode("div", null, [
              _createElementVNode("span", { class: "menu_icon" }, [
                _createElementVNode("img", {
                  src: "img/menu_site_setting.png",
                  alt: ""
                })
              ]),
              _createTextVNode(" 사이트 관리 ")
            ], -1)),
            (
                            $setup.route.path === '/mainPage' ||
                            $setup.route.path === '/reportList' ||
                            $setup.route.path === '/activityList' ||
                            $setup.route.path === '/activityManageList' ||
                            $setup.route.path === '/activityStateList' ||
                            $setup.route.path === '/eventList' ||
                            $setup.route.path === '/newsList' ||
                            $setup.route.path === '/archiveList' ||
                            $setup.route.path === '/qnaList' ||
                            $setup.state.isShowSub2
                        )
              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  ($setup.hasRole())
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: _normalizeClass({ active: $setup.route.path === '/mainPage' })
                      }, [
                        _createVNode(_component_router_link, { to: "/mainPage" }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("메인화면", -1)
                          ]))]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  ($setup.hasRole('report'))
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: _normalizeClass({ active: $setup.route.path === '/reportList' })
                      }, [
                        _createVNode(_component_router_link, { to: "/reportList" }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("시민제보창", -1)
                          ]))]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  ($setup.hasRole('board2'))
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 2,
                        class: _normalizeClass({ active: $setup.route.path === '/activityManageList' })
                      }, [
                        _createVNode(_component_router_link, { to: "/activityManageList" }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("시민활동관리", -1)
                          ]))]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  ($setup.hasRole('event'))
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 3,
                        class: _normalizeClass({ active: $setup.route.path === '/eventList' })
                      }, [
                        _createVNode(_component_router_link, { to: "/eventList" }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("캠페인·이벤트", -1)
                          ]))]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  ($setup.hasRole('news'))
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 4,
                        class: _normalizeClass({ active: $setup.route.path === '/newsList' })
                      }, [
                        _createVNode(_component_router_link, { to: "/newsList" }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("감시소식", -1)
                          ]))]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  ($setup.hasRole('news'))
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 5,
                        class: _normalizeClass({ active: $setup.route.path === '/archiveList' })
                      }, [
                        _createVNode(_component_router_link, { to: "/archiveList" }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode("자료집", -1)
                          ]))]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: $setup.route.path === '/qnaList' })
                  }, [
                    _createVNode(_component_router_link, { to: "/qnaList" }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("1:1 문의", -1)
                      ]))]),
                      _: 1
                    })
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ], 34),
          _createElementVNode("li", {
            class: _normalizeClass({ active: $setup.route.path === '/statistics' })
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, { to: "/statistics" }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("span", { class: "menu_icon" }, [
                    _createElementVNode("img", {
                      src: "img/menu_graph.png",
                      alt: ""
                    })
                  ], -1),
                  _createTextVNode(" 통계 ", -1)
                ]))]),
                _: 1
              })
            ])
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            href: $setup.state.userSiteUrl,
            target: "_blank"
          }, "반성매매 시민참여 플랫폼", 8, _hoisted_7)
        ]),
        _createElementVNode("div", null, _toDisplayString($setup.user.userInfo.name) + " 님", 1),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args))),
            type: "button"
          }, "로그아웃")
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}